import comp from "./EntityCohortsDetails.js";
export default comp;
